import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_608254b4 from 'nuxt_plugin_plugin_608254b4' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_plugin_3b367348 from 'nuxt_plugin_plugin_3b367348' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_axios_67956b44 from 'nuxt_plugin_axios_67956b44' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_recaptcha_d60d0c66 from 'nuxt_plugin_recaptcha_d60d0c66' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_208b23f4 from 'nuxt_plugin_cookieuniversalnuxt_208b23f4' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_graphqlrequest_a5ac046e from 'nuxt_plugin_graphqlrequest_a5ac046e' // Source: ./graphql-request.js (mode: 'all')
import nuxt_plugin_dayjsplugin_4f4ec8bf from 'nuxt_plugin_dayjsplugin_4f4ec8bf' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_deviceplugin_1503a3e9 from 'nuxt_plugin_deviceplugin_1503a3e9' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_pluginDelayHydrationclient_5968cde5 from 'nuxt_plugin_pluginDelayHydrationclient_5968cde5' // Source: ./hydration/pluginDelayHydration.client.mjs (mode: 'client')
import nuxt_plugin_pdpconstants_37deceef from 'nuxt_plugin_pdpconstants_37deceef' // Source: ../plugins/pdp-constants.js (mode: 'all')
import nuxt_plugin_route_192d86f8 from 'nuxt_plugin_route_192d86f8' // Source: ../plugins/route.js (mode: 'all')
import nuxt_plugin_accessibility_52423d5f from 'nuxt_plugin_accessibility_52423d5f' // Source: ../plugins/accessibility.js (mode: 'client')
import nuxt_plugin_vsanitize_a940db3e from 'nuxt_plugin_vsanitize_a940db3e' // Source: ../plugins/v-sanitize.js (mode: 'all')
import nuxt_plugin_vlazyimage_391f95a8 from 'nuxt_plugin_vlazyimage_391f95a8' // Source: ../plugins/v-lazy-image.js (mode: 'all')
import nuxt_plugin_readheadersserver_b9585c2a from 'nuxt_plugin_readheadersserver_b9585c2a' // Source: ../plugins/read-headers.server.js (mode: 'server')
import nuxt_plugin_jsonld_2ff766e1 from 'nuxt_plugin_jsonld_2ff766e1' // Source: ../plugins/jsonld.js (mode: 'all')
import nuxt_plugin_basePagination_206b2816 from 'nuxt_plugin_basePagination_206b2816' // Source: ../plugins/basePagination.js (mode: 'all')
import nuxt_plugin_isSpider_7771bdb2 from 'nuxt_plugin_isSpider_7771bdb2' // Source: ../plugins/isSpider.js (mode: 'all')
import nuxt_plugin_customDevice_2242bd8c from 'nuxt_plugin_customDevice_2242bd8c' // Source: ../plugins/customDevice.js (mode: 'all')
import nuxt_plugin_observeclient_844dc178 from 'nuxt_plugin_observeclient_844dc178' // Source: ../plugins/observe.client.js (mode: 'client')
import nuxt_plugin_klaviyoobserverclient_4d5ce564 from 'nuxt_plugin_klaviyoobserverclient_4d5ce564' // Source: ../plugins/klaviyo-observer.client.js (mode: 'client')
import nuxt_plugin_contextMenuFix_63f2fa5a from 'nuxt_plugin_contextMenuFix_63f2fa5a' // Source: ../plugins/contextMenuFix.js (mode: 'client')
import nuxt_plugin_errortracking_3589a2e5 from 'nuxt_plugin_errortracking_3589a2e5' // Source: ../plugins/error-tracking.js (mode: 'client')
import nuxt_plugin_cssCustomProperties_c0447034 from 'nuxt_plugin_cssCustomProperties_c0447034' // Source: ../plugins/cssCustomProperties.js (mode: 'all')
import nuxt_plugin_taskscheduler_e2d8e1c0 from 'nuxt_plugin_taskscheduler_e2d8e1c0' // Source: ../plugins/task_scheduler.js (mode: 'all')
import nuxt_plugin_auth_0c66c9dc from 'nuxt_plugin_auth_0c66c9dc' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../plugins/auth.js (mode: 'all')
import nuxt_plugin_integrationsaffirmclient56ffca92_1491c316 from 'nuxt_plugin_integrationsaffirmclient56ffca92_1491c316' // Source: ./integrations.affirm.client.56ffca92.js (mode: 'client')
import nuxt_plugin_integrationsbadgeclient4f5c3710_0bae0b8e from 'nuxt_plugin_integrationsbadgeclient4f5c3710_0bae0b8e' // Source: ./integrations.badge.client.4f5c3710.js (mode: 'client')
import nuxt_plugin_integrationsbreakpointsclienta8b527e2_4f1b97d6 from 'nuxt_plugin_integrationsbreakpointsclienta8b527e2_4f1b97d6' // Source: ./integrations.breakpoints.client.a8b527e2.js (mode: 'client')
import nuxt_plugin_integrationscriteoclient0929b51a_98dffc8e from 'nuxt_plugin_integrationscriteoclient0929b51a_98dffc8e' // Source: ./integrations.criteo.client.0929b51a.js (mode: 'client')
import nuxt_plugin_integrationsklavijoclient3671afc5_7e4ed408 from 'nuxt_plugin_integrationsklavijoclient3671afc5_7e4ed408' // Source: ./integrations.klavijo.client.3671afc5.js (mode: 'client')
import nuxt_plugin_integrationsliteyoutubeclient8de4249a_1e9af087 from 'nuxt_plugin_integrationsliteyoutubeclient8de4249a_1e9af087' // Source: ./integrations.lite-youtube.client.8de4249a.js (mode: 'client')
import nuxt_plugin_integrationspixelclient2537239a_8c922104 from 'nuxt_plugin_integrationspixelclient2537239a_8c922104' // Source: ./integrations.pixel.client.2537239a.js (mode: 'client')
import nuxt_plugin_integrationssyteapiclient186cdf10_772761c8 from 'nuxt_plugin_integrationssyteapiclient186cdf10_772761c8' // Source: ./integrations.syteapi.client.186cdf10.js (mode: 'client')
import nuxt_plugin_integrationsuetqclient56f81f7c_7924a40f from 'nuxt_plugin_integrationsuetqclient56f81f7c_7924a40f' // Source: ./integrations.uetq.client.56f81f7c.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"bodyAttrs":{"class":"nuxt-app"},"meta":[{"charset":"utf-8"},{"http-equiv":"Content-Type","content":"text\u002Fhtml; charset=utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"},{"hid":"facebook-domain-verification","name":"facebook-domain-verification","content":"6dm3ltvtx8ykflj2fllgy16eg31lhu"},{"hid":"p:domain_verify","name":"p:domain_verify","content":"84d319bb16f0870bae2b3a8f5a5b13b3"},{"hid":"og:type","property":"og:type","content":"website"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fmedia\u002Ffavicon\u002Fdefault\u002Ffavicon_4_1.ico"},{"rel":"shortcut icon","type":"image\u002Fx-icon","href":"\u002Fmedia\u002Ffavicon\u002Fdefault\u002Ffavicon_4_1.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,400;1,600&display=swap"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https:\u002F\u002Fgoogleads.g.doubleclick.net"},{"rel":"preconnect","href":"https:\u002F\u002Ftd.doubleclick.net"},{"rel":"preconnect","href":"https:\u002F\u002Fconnect.facebook.net"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.facebook.com"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.google.com"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.gstatic.com"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com"}],"script":[{"src":"\u002Fskin\u002Ffrontend\u002Fonestopbedrooms\u002Fdefault\u002Fjs\u002Froot-units.js","defer":true,"async":true},{"src":"\u002Fskin\u002Ffrontend\u002Fonestopbedrooms\u002Fdefault\u002Fjs\u002Flib\u002Fmodernizr.custom.min.js","defer":true},{"type":"application\u002Fld+json","innerHTML":"\n          {\n            \"@context\": \"https:\u002F\u002Fschema.org\",\n            \"@type\": \"Organization\",\n            \"@id\": \"Organization\",\n            \"name\": \"1StopBedrooms\",\n            \"image\": \"https:\u002F\u002Fwww.1stopbedrooms.com\u002Fskin\u002Ffrontend\u002Fonestopbedrooms\u002Fdefault\u002Fimages\u002F1stopbedrooms-img.png\",\n            \"url\": \"https:\u002F\u002Fwww.1stopbedrooms.com\u002F\",\n            \"logo\": \"https:\u002F\u002Fwww.1stopbedrooms.com\u002Fskin\u002Ffrontend\u002Fonestopbedrooms\u002Fdefault\u002Fimages\u002F1sb-svg-icons-redesign\u002Fillustration\u002Ficon-sb-logo-illustration-238x80-v3-32.svg\",\n            \"address\": {\n              \"@context\": \"https:\u002F\u002Fschema.org\",\n              \"@type\": \"PostalAddress\",\n              \"@id\": \"PostalAddress\",\n              \"streetAddress\": \"1716 Coney Island Ave\",\n              \"addressLocality\": \"Brooklyn\",\n              \"postalCode\": \"11230\",\n              \"addressRegion\": \"NY\",\n              \"addressCountry\": \"US\",\n              \"telephone\": \"866-456-8823\"\n            },\n            \"email\": \"info@1stopbedrooms.com\",\n            \"telephone\": \"866-456-8823\",\n            \"description\": \"1Stop Bedrooms is your one stop shop for bedroom furniture. Shop the largest collection of bedroom sets.  5 star rated. Free delivery. Financing available.\"\n          }\n        "}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_608254b4 === 'function') {
    await nuxt_plugin_plugin_608254b4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3b367348 === 'function') {
    await nuxt_plugin_plugin_3b367348(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_67956b44 === 'function') {
    await nuxt_plugin_axios_67956b44(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_d60d0c66 === 'function') {
    await nuxt_plugin_recaptcha_d60d0c66(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_208b23f4 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_208b23f4(app.context, inject)
  }

  if (typeof nuxt_plugin_graphqlrequest_a5ac046e === 'function') {
    await nuxt_plugin_graphqlrequest_a5ac046e(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_4f4ec8bf === 'function') {
    await nuxt_plugin_dayjsplugin_4f4ec8bf(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_1503a3e9 === 'function') {
    await nuxt_plugin_deviceplugin_1503a3e9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginDelayHydrationclient_5968cde5 === 'function') {
    await nuxt_plugin_pluginDelayHydrationclient_5968cde5(app.context, inject)
  }

  if (typeof nuxt_plugin_pdpconstants_37deceef === 'function') {
    await nuxt_plugin_pdpconstants_37deceef(app.context, inject)
  }

  if (typeof nuxt_plugin_route_192d86f8 === 'function') {
    await nuxt_plugin_route_192d86f8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_accessibility_52423d5f === 'function') {
    await nuxt_plugin_accessibility_52423d5f(app.context, inject)
  }

  if (typeof nuxt_plugin_vsanitize_a940db3e === 'function') {
    await nuxt_plugin_vsanitize_a940db3e(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyimage_391f95a8 === 'function') {
    await nuxt_plugin_vlazyimage_391f95a8(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_readheadersserver_b9585c2a === 'function') {
    await nuxt_plugin_readheadersserver_b9585c2a(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_2ff766e1 === 'function') {
    await nuxt_plugin_jsonld_2ff766e1(app.context, inject)
  }

  if (typeof nuxt_plugin_basePagination_206b2816 === 'function') {
    await nuxt_plugin_basePagination_206b2816(app.context, inject)
  }

  if (typeof nuxt_plugin_isSpider_7771bdb2 === 'function') {
    await nuxt_plugin_isSpider_7771bdb2(app.context, inject)
  }

  if (typeof nuxt_plugin_customDevice_2242bd8c === 'function') {
    await nuxt_plugin_customDevice_2242bd8c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_observeclient_844dc178 === 'function') {
    await nuxt_plugin_observeclient_844dc178(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_klaviyoobserverclient_4d5ce564 === 'function') {
    await nuxt_plugin_klaviyoobserverclient_4d5ce564(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_contextMenuFix_63f2fa5a === 'function') {
    await nuxt_plugin_contextMenuFix_63f2fa5a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_errortracking_3589a2e5 === 'function') {
    await nuxt_plugin_errortracking_3589a2e5(app.context, inject)
  }

  if (typeof nuxt_plugin_cssCustomProperties_c0447034 === 'function') {
    await nuxt_plugin_cssCustomProperties_c0447034(app.context, inject)
  }

  if (typeof nuxt_plugin_taskscheduler_e2d8e1c0 === 'function') {
    await nuxt_plugin_taskscheduler_e2d8e1c0(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_0c66c9dc === 'function') {
    await nuxt_plugin_auth_0c66c9dc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsaffirmclient56ffca92_1491c316 === 'function') {
    await nuxt_plugin_integrationsaffirmclient56ffca92_1491c316(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsbadgeclient4f5c3710_0bae0b8e === 'function') {
    await nuxt_plugin_integrationsbadgeclient4f5c3710_0bae0b8e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsbreakpointsclienta8b527e2_4f1b97d6 === 'function') {
    await nuxt_plugin_integrationsbreakpointsclienta8b527e2_4f1b97d6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationscriteoclient0929b51a_98dffc8e === 'function') {
    await nuxt_plugin_integrationscriteoclient0929b51a_98dffc8e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsklavijoclient3671afc5_7e4ed408 === 'function') {
    await nuxt_plugin_integrationsklavijoclient3671afc5_7e4ed408(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsliteyoutubeclient8de4249a_1e9af087 === 'function') {
    await nuxt_plugin_integrationsliteyoutubeclient8de4249a_1e9af087(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationspixelclient2537239a_8c922104 === 'function') {
    await nuxt_plugin_integrationspixelclient2537239a_8c922104(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationssyteapiclient186cdf10_772761c8 === 'function') {
    await nuxt_plugin_integrationssyteapiclient186cdf10_772761c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_integrationsuetqclient56f81f7c_7924a40f === 'function') {
    await nuxt_plugin_integrationsuetqclient56f81f7c_7924a40f(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
